import React, { Component } from "react";
// import DatePicker from "react-datepicker";
import moment from "moment";
import { UncontrolledTooltip, Badge, Input } from "reactstrap";
// import "react-datepicker/dist/react-datepicker.css";

const extractTimeDelta = ({  timeDeltaString }) => {
  let days; let months; let years; let con;
  let dez = timeDeltaString.split(' days')[0].split(' ');
  dez[1] ? days = dez[1] : days = dez[0] ? dez[0] : 0;
  let mnths = timeDeltaString.split(' months')[0].split(' ');
  mnths[1] ? months = mnths[1] : months = mnths[0] ? mnths[0] : 0;
  let yrs = timeDeltaString.split(' years')[0].split(' ');
  yrs[1] ? years = yrs[1] : years = yrs[0] ? yrs[0] : 0;
  if (timeDeltaString.indexOf('from now')) {
    con = moment().add(years, 'year').add(months, 'month').add(days, 'day');
  } else if (timeDeltaString.indexOf('ago')) {
    con = moment().subtract(years, 'year').subtract(months, 'month').subtract(days, 'day');
  }
  return con;
}

function getDefaultDate(val, otherval) {
  let convertedDate = "";
  // console.log(otherval.parentState.session_date)
  console.log({val})
  if (val == 'sessiondate') {
    convertedDate = otherval.parentProps.parentState.session_date;
  } else if (val == 'today') {
    convertedDate = new Date();
  } else {
    convertedDate = extractTimeDelta({ dateValue: otherval.parentState.pageData.val, timeDeltaString: val });
  }
  return convertedDate;
}

function dateDiff(date) {
  var separators = [" ", "\\+", "-", "\\(", "\\)", "\\*", "/", ":", "\\?"];
  date = date.split(new RegExp(separators.join("|"), "g"));
  var today = new Date();
  var year = today.getFullYear();
  var month = today.getMonth() + 1;
  var day = today.getDate();
  var yy = parseInt(date[0]);
  var mm = parseInt(date[1]);
  var dd = parseInt(date[2]);
  var years, months, days;
  var returnDate = "";
  // months
  months = month - mm;
  if (day < dd) {
    months = months - 1;
  }
  // years
  years = year - yy;
  if (month * 100 + day < mm * 100 + dd) {
    years = years - 1;
    months = months + 12;
  }
  // days
  days = Math.floor(
    (today.getTime() - new Date(yy + years, mm + months - 1, dd).getTime()) /
    (24 * 60 * 60 * 1000)
  );
  //
  returnDate = years + "years , " + months + " months , " + days + " days ago";
  return returnDate;
}

function calculateFutureDate(c, a) {
  const current = c.clone(), action = a
  let final = null;
  let amt = parseInt(action.split(" ")[0]);
  if (action.indexOf("ago") != -1) {
    if (action.indexOf("year") != -1) {
      final = current.subtract(amt, "year");
    } else if (action.indexOf("month") != -1) {
      final = current.subtract(amt, "month");
    } else if (action.indexOf("day") != -1) {
      final = current.subtract(amt, "day");
    }
  } else if (action.indexOf("from now") != -1) {
    if (action.indexOf("year") != -1) {
      final = current.add(amt, "year");
    } else if (action.indexOf("month") != -1) {
      final = current.add(amt, "month");
    } else if (action.indexOf("day") != -1) {
      final = current.add(amt, "day");
    }
  }
  return final;
}

function convert(str) {
  let datestring;
  if (typeof str == 'number') {
    datestring = new Date(moment(String(str)))
  } else {
    datestring = new Date(str)
  }

  var date = datestring,
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
}



function getBirthdayToAge(birthDateString) {
  const today = new Date();
  const birthDate = new Date(birthDateString);

  const yearsDifference = today.getFullYear() - birthDate.getFullYear();

  if (
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
  ) {
    return yearsDifference - 1;
  }

  return yearsDifference;
}

//(selectedYear-1)
class DatePickerCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {


    let { displayFormat, outputFormat, convertedTo } = this.props.component
    !displayFormat && (displayFormat = "DD/MM/YYYY");
    !outputFormat && (outputFormat = "YYYYMMDD");
    let dateNew;

    if (e.target.value) {
      dateNew = new Date(e.target.value);
    } else {
      dateNew = "";
    }

    if (convertedTo) {
      console.log(e.target.value)
      let currentage = getBirthdayToAge(e.target.value)
      this.props.liftState({ name: convertedTo }, currentage);

    }
    // let dateNew=e.target.value;
    // let dateNew = {
    //   label: e.target.value,
    //   mongodate:new Date(e.target.value),
    //   value: moment(e.target.value).format('YYYYMMDD'),
    //   componentValue: e.target.value

    // };
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    this.props.liftState(this.props.component, dateNew);

    //  setTimeout(() => {
    //   let convertedDiff= "";
    //   convertedDiff = dateDiff(e.format(this.props.component.displayFormat));
    //   if (this.props.component.convertedTo === "differDate") {
    //     this.props.liftState({ name: "differDate" }, convertedDiff);
    //   }
    // }, 2000);

  }

  // handleInputChange = value => {
  //   let { displayFormat, outputFormat } = this.props.component;
  //   !displayFormat && (displayFormat = "DD/MM/YYYY"); 
  //   !outputFormat && (outputFormat = "YYYYMMDD"); 
  //   if (value.length == 6 || value.length == 8) {
  //     let ipformat;
  //     value.length == 6 ? (ipformat = "DDMMYY") : (ipformat = "DDMMYYYY");
  //     let converted = moment(value, ipformat).format(displayFormat);
  //     let pushkar = moment(value, ipformat).format(outputFormat);

  //     let dateNew = {
  //       label: converted, // string
  //       value: parseInt(pushkar), // number
  //       mongodate:new Date(moment(value, ipformat)), // date object
  //       componentValue: moment(value, ipformat) // moment object
  //     };

  //     this.props.liftState(this.props.component, dateNew);
  //   }
  // };
  componentDidMount() {
    // let {pageData}=this.props.parentState;
    // let {defaultValue,name,} = this.props.component;


    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    // console.log({name}); 
    // console.log({defaultValue})
    // console.log({pageData})
    // console.log({modalname})
    if (pageData &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue && !defaultValue.parent) {
      // console.log({name});  
      let defval = getDefaultDate(defaultValue, this.props);
      // console.log({defaultValue})
      this.props.liftState(this.props.component, defval);
    }
  }

  generateID() {
    return this.state.ttid;
  }
  generateID2() {
    return this.state.ttid;
  }

  render() {
    // this.props.parentState.pageData[name] = 20180305. {value:20180305,label:"05/03/2017"}
    const {
      name,
      label,
      placeHolder,
      convertedTo,
      dateType,
      isRequired,
      description,
      showTime,
      excludeTimes,
      highlightDates,
      displayFormat,
      outputFormat,
      defaultValue, isReadOnly
    } = this.props.component;

    let { conditionalRender } = this.props;

    let { LocalVars } = this.props.parentState;
    let { compressed } = LocalVars;

    let { currentPage, fileFolder, formState, pageData, openmodals, modalname } = this.props.parentState;
    let isReadOnly1 = false;
    
    if ( (pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly!='edit') ) {
      isReadOnly1 = true;
    }

    let boxvalue;
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? convert(pageData[modalname][name])
        : "";
    } else {
      boxvalue = pageData[name]
        ? convert(pageData[name])
        : "";
    }
    // console.log(pageData);
    // console.log({boxvalue})
    // console.log({pageData})

    let textType = "date";
    let newv = null;

    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    return (


      <div className={`form-group   ${this.props.component.widths.parent}`}>
        {conditionalRender && conditionalRender != 'blank' &&

          // {label &&
          //   label != "" && (
          //     <span>
          //       <label
          //         id={tooltipID}
          //         className={`col-form-label col-form-label-sm nopadding`}
          //       >
          //         {label} {" " + this.state.errorMessage}
          //       </label>

          //       {description ? (
          //         <UncontrolledTooltip placement="right" target={tooltipID}>
          //           {description}
          //         </UncontrolledTooltip>
          //       ) : (
          //           ""
          //         )}
          //     </span>
          //   )}
          // {" " + this.props.parentState.errorMessages != undefined &&
          //   this.props.parentState.errorMessages[name] ? (
          //     <span>
          //       <UncontrolledTooltip placement="right" target={tooltipID2}>
          //         can not empty{" "}
          //       </UncontrolledTooltip>
          //     </span>
          //   ) : (
          //     ""
          //   )}

          <div className="input-group input-group-sm">
            {this.props.component.prepend && (
              <div className="input-group-prepend">
                <div className="input-group-text">
                  {this.props.component.prepend}
                </div>
              </div>
            )}
            <Input
              type="date"
              className={`col-12 form-control form-control-sm primary ${!compressed ? 'input-compressed' : ''} ${
                this.props.parentState.errorMessages != undefined &&
                  this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
                }`}
              name={name}
              // selected={boxvalue}
              defaultValue={boxvalue}
              readOnly={isReadOnly1}
              // dateformat="yyyy-mm-dd"
              onChange={this.handleChange}
              id={tooltipID2}
              placeholder={placeHolder}
            />

            {/* {(!dateType || dateType === "default") && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              dateFormat={displayFormat}
              onChange={this.handleChange}
              placeholderText={placeHolder}
            />
          )}
          {dateType === "ontype" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              onChangeRaw={event => this.handleInputChange(event.target.value)}
              dateFormat={displayFormat} //YYYY/MM/DD for 2017/02/01
            />
          )}
          {dateType === "month" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showMonthDropdown
              dateFormat="DD/MM/YYYY"
            />
          )}
          {dateType === "shortmonth" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showMonthDropdown
              useShortMonthInDropdown
              dateFormat="DD/MM/YYYY"
            />
          )}
          {dateType === "timeonly" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              dateFormat="LT"
              timeCaption="Time"
            />
          )}
          {dateType === "excludetime" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showTimeSelect
              excludeTimes={[
                moment()
                  .hours(17)
                  .minutes(0),
                moment()
                  .hours(18)
                  .minutes(30),
                moment()
                  .hours(19)
                  .minutes(30),
                moment()
                  .hours(17)
                  .minutes(30)
              ]}
              dateFormat="LLL"
            />
          )}
          {dateType === "includetime" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showTimeSelect
              includeTimes={[
                moment()
                  .hours(17)
                  .minutes(0),
                moment()
                  .hours(18)
                  .minutes(30),
                moment()
                  .hours(19)
                  .minutes(30),
                moment()
                  .hours(17)
                  .minutes(30)
              ]}
              dateFormat="LLL"
            />
          )}
          {dateType === "injectspecifictimes" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showTimeSelect
              timeFormat="HH:mm"
              injectTimes={[
                moment()
                  .hours(0)
                  .minutes(1),
                moment()
                  .hours(12)
                  .minutes(5),
                moment()
                  .hours(23)
                  .minutes(59)
              ]}
              dateFormat="LLL"
            />
          )}
          {dateType === "timerange" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showTimeSelect
              minTime={moment()
                .hours(17)
                .minutes(0)}
              maxTime={moment()
                .hours(20)
                .minutes(30)}
              dateFormat="LLL"
            />
          )}
          {dateType === "customcalender" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              calendarClassName="rasta-stripes"
            />
          )}
          {dateType === "customdayclass" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dayClassName={date =>
                date.date() < Math.random() * 31 ? "random" : undefined
              }
            />
          )}
          {dateType === "daterange" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              minDate={moment()}
              maxDate={moment().add(5, "days")}
              placeholderText="Select a date between today and 5 days in the future"
            />
          )}
          {dateType === "year" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showYearDropdown
              dateFormatCalendar="MMMM"
              scrollableYearDropdown
              yearDropdownItemNumber={15}
              dateFormat="DD/MM/YYYY"
            />
          )}
          {dateType === "Locale" && ( //not work
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              locale="en-gb"
              placeholderText="Weeks start on Monday"
            />
          )}
          {dateType === "exculdedate" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              excludeDates={[moment(), moment().subtract(1, "days")]}
              placeholderText="Select a date other than today or yesterday"
            />
          )}
          {dateType === "inculdedate" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              includeDates={[moment(), moment().add(1, "days")]}
              placeholderText="This only includes today and tomorrow"
            />
          )}
          {dateType === "filterdate" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              filterDate={this.isWeekday}
              placeholderText="Select a weekday"
            />
          )}
          {dateType === "DateRange" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              // onChange={this.handleChange}
              selectsStart
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onChange={this.handleChangeStart}
            />
          )}
          {dateType === "disablekeyboard" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              disabledKeyboardNavigation
              placeholderText="This has disabled keyboard navigation"
            />
          )}
          {dateType === "tabindex" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              tabIndex={1}
            />
          )}
          {dateType === "OpenDate" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              openToDate={moment("1993-09-28")}
              selected={boxvalue}
              onChange={this.handleChange}
            />
          )}
          {dateType === "FixedHeight" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              fixedHeight
              selected={boxvalue}
              onChange={this.handleChange}
            />
          )}
          {dateType === "MultiMonthsYear" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showYearDropdown
              monthsShown={2}
            />
          )}
          {dateType === "DateSelection" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              shouldCloseOnSelect={false}
            />
          )}
          {dateType === "MultiMonthInline" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              inline
              selected={boxvalue}
              onChange={this.handleChange}
              monthsShown={2}
            />
          )}
          {dateType === "readonly" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              // onChange={this.handleChange}
              readOnly={true}
              placeholderText="This is readOnly"
            />
          )}

          {dateType === "timeselect" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              showTimeSelect
              dateFormat="DD/MM/YYYY HH:mm"
              timeIntervals={15}
            />
          )}
          {dateType === "monthyear" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormatCalendar={"MMM YYYY"}
              minDate={moment().subtract(6, "month")}
              maxDate={moment().add(6, "month")}
              showMonthYearDropdown
            />
          )}
          {dateType === "weekdates" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
              showWeekNumbers
            />
          )}
          {dateType === "multimonths" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
              monthsShown={2}
            />
          )}
          {dateType === "datehighlight" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              dateFormat="DD/MM/YYYY"
              onChange={this.handleChange}
              highlightDates={[
                moment().subtract(7, "days"),
                moment().add(7, "days")
              ]}
            />
          )}
          {dateType === "childern" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
            >
              <div style={{ color: "red" }}>
                Don't forget to check the weather!
              </div>
            </DatePicker>
          )}
          {dateType === "withportal" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
              withPortal
            />
          )}
          {dateType === "popperproperties" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              popperClassName="some-custom-class"
              popperPlacement="top-end"
              popperModifiers={{
                offset: {
                  enabled: true,
                  offset: "5px, 10px"
                },
                preventOverflow: {
                  enabled: true,
                  escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                  boundariesElement: "viewport"
                }
              }}
            />
          )}
          {dateType === "clearinput" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12  ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
              isClearable={true}
            />
          )}
          {dateType === "disabled" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              disabled={true}
            />
          )}
          {dateType === "customclass" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              className="red-border"
            />
          )}
          {dateType === "todaybutton" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              todayButton={"Today is Ganesh Chathurthii"}
            />
          )}
          {dateType === "multimonthsinline" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              // selected={boxvalue}
              inline
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
              monthsShown={2}
            />
          )}
          {dateType === "yearselectdropdown" && (
            <DatePicker
              id={tooltipID2}
              className={`col-12 form-control form-control-sm primary ${
                this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                  ? "validationErrorBox"
                  : ""
              }`}
              selected={boxvalue}
              onChange={this.handleChange}
              dateFormat="DD/MM/YYYY"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              onChangeRaw={event => this.handleInputChange(event.target.value)}
              dropdownMode="select"
            />
          )} */}
          </div>
        }
      </div>
    );
  }
}

export default DatePickerCustom;
